
import {defineComponent, onMounted, reactive, ref, watch} from "vue";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import DateTime from "@/components/common/DateTime.vue";
import AffiliateStatus from "@/components/affiliates/AffiliateStatus.vue";
// import AffiliateEditModal from "@/components/modals/forms/AffiliateEditModal.vue";

export default defineComponent({
  name: "affiliates-listing",
  components: {
    AffiliateStatus,
    DateTime,
    // AffiliateEditModal
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("Afiliados", []);
      load()
    });

    const tableData = ref([]);
    const filterProperties = ref({
      email: ""
    });

    let searching;
    const filterList = (): void => {
      clearTimeout(searching)
      searching = setTimeout(() => load(), 700)
    };

    const load = (): void => {
      ApiService.setHeader();
      ApiService.get(`v1/backend/affiliates?page=${pagination.page}`, {
        params: filterProperties.value
      })
          .then(({data}) => {
            tableData.value = data.data;
            pagination.page = data.current_page;
            pagination.total = data.total;
          })
          .catch(({response}) => {
            console.log(response);
          });
    };

    const pagination = reactive({
      page: 1,
      total: 0,
    })

    return {
      tableData,
      filterList,
      load,
      filterProperties,
      pagination,
    };
  },
});
